exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a5d390f8] .el-icon-upload{color:#45f2eb}[data-v-a5d390f8] .el-upload__text{color:#fff}[data-v-a5d390f8] .el-card__body{height:100%}[data-v-a5d390f8] .el-tabs{height:calc(100% - 70px)}[data-v-a5d390f8] .el-tabs__content{height:calc(100% - 55px);overflow-y:auto}[data-v-a5d390f8] .el-tab-pane{height:100%}[data-v-a5d390f8] .el-form-item__label{text-align:right}[data-v-a5d390f8] .el-upload{width:100%}", ""]);

// exports
